// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"560":"f7474a49","658":"b2bd8b39"}[chunkId] + ".chunk.css";
};